
import pig from '../img/pig.svg'
import creditCard from '../img/credit-card.svg'
import home from '../img/home.svg'
import loans from '../img/loans.svg'
import investing from '../img/investing.svg'
import student from '../img/sudent.svg'

const offerData = () => {

  return [
    {
      title: "Accounts",
      img: pig,
      index: 0,
    },

    {
      title: "Cards",
      img: creditCard,
      index: 1,
    },

    {
      title: "Mortgage",
      img: home,
      index: 2,
    },

    {
      title: "Loans",
      img: loans,
      index: 3,
    },

    {
      title: "Investing",
      img: investing,
      index: 4,
    },

    {
      title: "Students",
      img: student,
      index: 5,
    },
  ];
};

export default offerData;
